import PropTypes from 'prop-types';
import logo from 'client/pages/MapPage/components/OSBranding/img/os-logo-maps.svg';
import logoWhite from 'client/pages/MapPage/components/OSBranding/img/os-logo-maps-white.svg';

import styles from './OSBranding.module.scss';

const OSBranding = props => {
    return (
        <div
            className={styles.container}
            data-testid='osBranding'
        >
            <img className={styles.img} src={props?.white ? logoWhite : logo} alt="OS Branding"/>
        </div>
    );
};

OSBranding.propTypes = {
    white: PropTypes.bool
};

OSBranding.defaultProps = {
    white: false
};

export default OSBranding;
